import { ReactNode } from 'react'

import { HStack, QuickTip, T } from 'govwell-ui'

import { getIsRichTextEmpty } from 'src/components/form/util'
import RenderedRichTextInput from 'src/components/RenderedRichTextInput/RenderedRichTextInput'

type Props = {
  label: ReactNode
  tooltip?: string | null
}
export const Label = (props: Props) => {
  const { label, tooltip } = props

  const renderedLabel = typeof label === 'string' ? <T.Label>{label}</T.Label> : label

  if (!getIsRichTextEmpty(tooltip)) {
    return (
      <HStack gap={1}>
        {renderedLabel}
        <QuickTip
          content={<RenderedRichTextInput>{tooltip}</RenderedRichTextInput>}
          // Rich-text tooltips can contain links, so keep them click-controlled for accessibility.
          trigger="click"
        />
      </HStack>
    )
  }

  return renderedLabel
}
